<div class="shared-modal-wrapper modal-container" [style.max-width]="maxWidth()" [class.up]="isDialogPositionUp()">
  <div #header>
    <ng-content select="[header]" />
  </div>
  @if (!header.hasChildNodes()) {
    <div class="shared-modal-header bg-light align-items-center">
      <div></div>
      <h3 class="text-18 bold-800 text-center">{{ headline() }}</h3>
      @if (showCloseButton()) {
        <button pButton class="p-button p-button-primary p-button-outlined medium icon-only" (click)="emitCloseForm()">
          <shared-icon icon="cross" width="1rem" height="1rem" />
        </button>
      }
    </div>
  }
  <div class="shared-modal-body" [ngClass]="contentStyleClass()" #body>
    <ng-content />
  </div>
</div>
